export const tabProfile  = [
    {
        title: "ข้อมูลทั่วไป",
        icon: "cup",
        slugProfile: "detail",
        tabs: [
          {
            title: "ข้อมูลทั่วไป",
            name: "TAX_1"
          },
        ]
    },
    {
      title: "สถานภาพส่วนตัว",
      icon: "cup",
      slugProfile: "personalStatus",
      tabs: [
        {
          title: "สถานภาพส่วนตัว",
          name: "TAX_1"
        },
      ]
    },
    {
      title: "ข้อมูลสิทธิ",
      icon: "cup",
      slugProfile: "personalInformation",
      tabs: [
        {
          title: "ข้อมูลบุคลากร",
          name: "TAX_1"
        },
      ]
    },
    {
      title: "ที่อยู่ปัจจุบัน",
      icon: "cup",
      slugProfile: "address",
      tabs: [
        {
          title: "ที่อยู่ปัจจุบัน",
          name: "TAX_1"
        },
      ]
    },
]
  
export const datasetsProfileDetail = [
    {
      catrgoryName: 'detail',
      Tab:[
        {
          name: 'TAX_1',
          form:[
            {
              name:'form1',
              title: 'รหัส',
              formValue:[
                {
                    label: "รหัสบุคลากร",
                    keyMapdata: "empCode",
                    typeData: "",
                    value: '',
                    col: 12,
                    offset:0
                },
                {
                  label: "สำนัก/ฝ่าย",
                  keyMapdata: "divisionName",
                  typeData: "cutText",
                  value: '',
                  col: 12,
                  offset:0
              },
              ]
            },  
            {
              name:'form2',
              title: 'ข้อมูล',
              formValue:[
                {
                  label: "ชื่อ",
                  keyMapdata: "nameDetail",
                  typeData: "nameDetail",
                  value: '',
                  col: 12,
                  offset:0
                },
                // {
                //   label: "ชื่อ(Eng)",
                //   keyMapdata: "nameEng",
                //   typeData: "",
                //   value: '',
                //   col: 12,
                //   offset:0
                // },
                {
                  label: "วันเกิด",
                  keyMapdata: "birthDate",
                  typeData: "date",
                  value: '',
                  col: 12,
                  offset:0
                },
                {
                  label: "อายุ",
                  keyMapdata: "birthDate",
                  typeData: "age",
                  value: '',
                  col: 12,
                  offset:0
                },
                {
                    label: "เพศ",
                    keyMapdata: "gender",
                    typeData: "",
                    value: '',
                    col: 12,
                    offset:0
                },
                {
                    label: "หมู่เลือด",
                    keyMapdata: "bloodGroups",
                    typeData: "",
                    value: '',
                    col: 12,
                    offset:0
                },
                {
                  label: "สัญชาติ",
                  keyMapdata: "nationality",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
                },
                {
                    label: "เชื้อชาติ",
                    keyMapdata: "race",
                    typeData: "",
                    value: '',
                    col: 12,
                    offset:0
                },
                {
                    label: "ศาสนา",
                    keyMapdata: "religion",
                    typeData: "",
                    value: '',
                    col: 12,
                    offset:0
                },
              ]
            },
          ]
        },
      ]
    },
]

export const datasetsPersonalStatus = [
  {
    catrgoryName: 'personalStatus',
    Tab:[
      {
        name: 'TAX_1',
        form:[
          {
            name:'form1',
            title: 'หมายเลขบัตรประชาชน',
            formValue:[
              {
                  label: "หมายเลขบัตรประชาชน/เลขผู้เสียภาษี",
                  keyMapdata: "identityCard",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ออกให้โดย",
                  keyMapdata: "identityCardIssueAt",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "วันที่ออกบัตร",
                  keyMapdata: "identityCardDate",
                  typeData: "date",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "วันที่บัตรหมดอายุ",
                  keyMapdata: "identityCardExpire",
                  typeData: "date",
                  value: '',
                  col: 12,
                  offset:0
              },
            ]
          },
          {
            name:'form2',
            title: 'ใบอนุญาตทำงาน (กรณีบุคลากรเป็นชาวต่างชาติ)',
            formValue:[
              {
                  label: "เลขที่หนังสือเดินทาง",
                  keyMapdata: "passportNo",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
            ]
          },
          {
            name:'form3',
            title: 'สถานภาพสมรส',
            formValue:[
              {
                  label: "สถานะ",
                  keyMapdata: "maritalStatus",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                label: "จดทะเบียนเมื่อ",
                keyMapdata: "marryDate",
                typeData: "date",
                value: '',
                col: 12,
                offset:0
              },
            ]
          },
          {
            name:'form3',
            title: 'สถานภาพทางการทหาร',
            formValue:[
              {
                  label: "สถานะ",
                  keyMapdata: "militaryStatus",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
            ]
          },
        ]
      },
    ]
  },
]

export const datasetsPersonalInformation = [
  {
    catrgoryName: 'personalInformation',
    Tab:[
      {
        name: 'TAX_1',
        form:[
          {
            name:'form1',
            title: 'ข้อมูลบุคลากร',
            formValue:[
              {
                  label: "รหัสแพทย์/รหัสอ้างอิง",
                  keyMapdata: "refCode",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ต้นสังกัด",
                  keyMapdata: "agency",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "รายละเอียดเพิ่มเติม",
                  keyMapdata: "remark",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "สิทธิการจอดรถ",
                  keyMapdata: "carpark",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                label: "หมายเหตุสิทธิการจอดรถ",
                keyMapdata: "carparkRemark",
                typeData: "",
                value: '',
                col: 24,
                offset:0
            },
            ]
          },
        ]
      },
    ]
  },
]

export const datasetsAddress = [
  {
    catrgoryName: 'address',
    Tab:[
      {
        name: 'TAX_1',
        form:[
          {
            name:'form1',
            title: 'ที่อยู่ที่ติดต่อได้',
            formValue:[
              {
                  label: "ชื่อที่อยู่",
                  keyMapdata: "address.addressName",
                  typeData: "",
                  value: '',
                  col: 24,
                  offset:0
              },
              {
                  label: "เลขที่",
                  keyMapdata: "address.addressNo",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "หมู่ที่",
                  keyMapdata: "address.groupNo",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "อาคาร",
                  keyMapdata: "address.building",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "เลขที่ห้อง",
                  keyMapdata: "address.roomNo",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ชั้นที่",
                  keyMapdata: "address.floorNo",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "หมู่บ้าน",
                  keyMapdata: "address.vilage",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ตรอกซอย/ซอย",
                  keyMapdata: "address.lane",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ถนน",
                  keyMapdata: "address.street",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ตำบล/แขวง",
                  keyMapdata: "address.district",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                label: "อำเภอ/เขต",
                keyMapdata: "address.amphur",
                typeData: "",
                value: '',
                col: 12,
                offset:0
              },
              {
                  label: "จังหวัด",
                  keyMapdata: "address.province",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "รหัสไปรษณีย์",
                  keyMapdata: "address.postalCode",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "ประเทศ",
                  keyMapdata: "address.country",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "เบอร์โทรศัพท์",
                  keyMapdata: "address.phone1",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "อีเมล",
                  keyMapdata: "address.email1",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              {
                  label: "โทรสาร",
                  keyMapdata: "address.fax",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
              // {
              //     label: "ข้อมูลผู้ติดต่อ",
              //     keyMapdata: "address.contactName",
              //     typeData: "",
              //     value: '',
              //     col: 12,
              //     offset:0
              // },
              {
                  label: "โทรศัพท์/มือถือ",
                  keyMapdata: "address.mobilePhone",
                  typeData: "",
                  value: '',
                  col: 12,
                  offset:0
              },
            ]
          },
        ]
      },
    ]
  },
]